export default __webpack_public_path__ + "static/photo-23-ff952da0b1904ec9af6340c488f726b9.jpg";